module.exports = __webpack_public_path__ + "media/img/sbt-test/mastercard-c9f0f9c3a6f51013e05fcfcb6087c746.svg";